module.exports = __webpack_public_path__ + "img/知识讲堂.04275d4a.png";